<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import RvApi from "@/rvapi";
import type { Device } from "@/rvapi";
import LogList from "@/components/LogList.vue";
import OrderList from "@/components/OrderList.vue";
import LogWriter from "@/components/LogWriter.vue";
import DeviceDetails from "@/components/DeviceDetails.vue";

const route = useRoute();
const router = useRouter();
const deviceId = ref(route.params.id as string);
const device = ref(undefined as Device | undefined);
const loaded = ref(false);
onMounted(async () => {
  const devices = await RvApi.searchDevices(deviceId.value);
  if (devices && devices.length > 0) {
    device.value = devices[0];
  } else {
    const old = await RvApi.searchLegacyDevice(deviceId.value);
    if (old && old.length > 0) {
      router.replace({ path: `/legacydevice/${deviceId.value}` });
    }
  }
  loaded.value = true;
});
</script>

<template>
  <h1>Device</h1>
  <pn-spinner size="4" v-show="!loaded" />
  <div v-if="!device && loaded">No device found</div>
  <section v-if="device">
    <h2>Details</h2>
    <DeviceDetails :simple="false" :device="device" />
  </section>
  <section v-if="!!device">
    <OrderList type="device" :searchId="deviceId" />
  </section>
  <section v-if="!!device">
    <LogWriter :deviceId="deviceId" :userId="device.userId" />
  </section>
  <section v-if="!!device">
    <LogList type="device" :searchId="deviceId" />
  </section>
</template>
